import React from 'react';
import { useTranslation } from 'react-i18next';
import MobileSubmitMenuItem from '../../../_partials/MobileSubmitMenuItem';
import { mobileSubmitMenuItems } from '../../../constants';
import s from './SubmitMenu.scss';
var SubmitMenu = function (_a) {
    var isLegacyHeader = _a.isLegacyHeader, isOpen = _a.isOpen;
    var t = useTranslation().t;
    return (React.createElement("ul", { className: s['root'], "aria-hidden": !isOpen }, mobileSubmitMenuItems.map(function (_a) {
        var label = _a.label, link = _a.link, verificationAction = _a.verificationAction, type = _a.type, modalType = _a.modalType, modalOptions = _a.modalOptions;
        return (React.createElement("li", { className: s['menu-item'], key: label },
            React.createElement(MobileSubmitMenuItem, { type: type, link: link, modalType: modalType, modalOptions: modalOptions, isLegacyHeader: isLegacyHeader, verificationAction: verificationAction, tabIndex: isOpen ? 0 : -1, className: s['button'] }, t(label))));
    })));
};
SubmitMenu.displayName = 'SubmitMenu';
export default SubmitMenu;
//# sourceMappingURL=SubmitMenu.js.map